import { connect } from 'react-redux';
import {
  fetchReservationUpcoming,
  updateReservationStatus,
  unlinkReservation
} from '../../../redux/Reservation/sagas/routines';
import {
  getIsFetching,
  getIsSaving,
  getOrder
} from '../../../redux/Reservation/selectors/upcoming';
import {
  clearReservationUpcoming,
  reservationUpcomingOnChangePage,
  reservationUpcomingOnChangeOrder
} from '../../../redux/Reservation/actions/upcoming';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Reservation/selectors/upcoming/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import SEARCH_CONTEXT from '../../../constants/reservation/SearchContext';
import { CANCEL } from '../../../constants/reservation/StatusActions';
import ReservationList from '../../../components/reservations/List';
import mergeListQueries from '../../../helpers/mergeListQueries';
import orderList from '../../../helpers/reservationOrderList';
import {
  setReservationsSearchQueryCookie,
  getReservationsSearchQueryCookie,
  getReservationsRememberFlagCookie
} from '../../../services/currentUserCookie';
import { hasPortalFeature } from '../../../helpers/config';
import { fetchSmtpAccounts } from '../../../redux/Settings/sagas/portal/smtp-account/routines';
import { SMTP_TYPES } from '../../../constants/smtp-account';
import { getHasActiveSmtpAccount } from '../../../redux/Settings/selectors/portal/smtp-account';

const context = SEARCH_CONTEXT.UPCOMING;

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, context);
  const order = getOrder(state);

  const isUseQueryCookie = getReservationsRememberFlagCookie(context);
  const query = isUseQueryCookie
    ? getReservationsSearchQueryCookie(context)
    : mergeListQueries(paginationQuery, searchQuery, order);

  return {
    query,
    items: orderList(order, getCurrentPageItems(state)),
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isNotifyGuestEnabled: hasPortalFeature,
    isFetching: getIsFetching(state),
    isSaving: getIsSaving(state),
    hasActiveSmtpAccounts: getHasActiveSmtpAccount(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchReservationUpcoming(query || {}));
      dispatch(fetchSmtpAccounts({ type: SMTP_TYPES.GMAIL }));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchReservationUpcoming(query));
      else dispatch(reservationUpcomingOnChangePage(page));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, query);
      }
    },
    onChangeLimit: query => {
      dispatch(clearReservationUpcoming());
      dispatch(fetchReservationUpcoming(query));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, query);
      }
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      const updatedQuery = { ...query, order };
      dispatch(clearReservationUpcoming());
      dispatch(fetchReservationUpcoming(updatedQuery));
      dispatch(reservationUpcomingOnChangeOrder(order));

      const isUseQueryCookie = getReservationsRememberFlagCookie(context);
      if (isUseQueryCookie) {
        setReservationsSearchQueryCookie(context, updatedQuery);
      }
    },
    onCancel: (id, notifyGuest, email, cancellationReason) => {
      const body = { notifyGuest, email, cancellationReason };
      dispatch(updateReservationStatus({ id, body, statusAction: CANCEL }));
    },
    onUnlink: (id, body) => {
      dispatch(unlinkReservation({ id, body }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationList);
